module.exports = __webpack_public_path__ + "static/media/webappMobileProfile.52da5507.png";